<div mat-dialog-title class="dialog-title">
  <eon-ui-icon fxLayout fxLayoutAlign="end" [mat-dialog-close]="{status: 'closed'}" class=closeX
               name="close"></eon-ui-icon>
  <div
    class="headline">Are you sure?</div>
</div>
<div mat-dialog-actions style="justify-content: space-between;">
  <eon-ui-button scheme="redInverted" text="Cancel"
                 [mat-dialog-close]="{status: 'closed'}"></eon-ui-button>
  <eon-ui-button text="Yes" [mat-dialog-close]="{status: 'ok'}"></eon-ui-button>
</div>
